// extracted by mini-css-extract-plugin
export default {"goodReport":"GoodReport_goodReport__g8B-2","controlPanel":"GoodReport_controlPanel__9rU-s","scrollable":"GoodReport_scrollable__WYEYZ"};